
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-subtitle-remover",
      function () {
        return require("private-next-pages/video-subtitle-remover/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-subtitle-remover"])
      });
    }
  